import React from 'react';
import NumberFormat from 'react-number-format';

export const ThongTinHanhChinh = (props) => {
    const ShowEdit = () => {
        props.showEditThongTin();
    }
    return (
        <div className="thong-tin">
            {
                props.thongTin.tenHuyen ? <table className="table table-bordered" width="100%">
                    <thead>
                        <tr>
                            <th colSpan="2"> Bản đồ hành chính huyện
                            {
                                    props.admin ? <button type="button" className="btn btn-primary btn-sm suathongtin" onClick={ShowEdit}><i className='fas fa-edit'></i></button> : ''
                                }
                            </th>
                        </tr>
                        <tr>
                            <th className="col-name">Tên</th>
                            <th>Thông tin</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="col-name">Tỉnh</td>
                            <td>{props.thongTin?.tenTinh}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Huyện</td>
                            <td>{props.thongTin?.tenHuyen}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Năm</td>
                            <td>{props.thongTin?.nam}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Diện tích (km2)</td>
                            <td>
                                <NumberFormat value={props.thongTin?.DienTichKm2} displayType={'text'} thousandSeparator={true} decimalScale={2}></NumberFormat>
                            </td>
                        </tr>
                        <tr>
                            <td className="col-name">Dân số (nghìn)</td>
                            <td>
                                <NumberFormat value={props.thongTin?.tbDanSo1000} displayType={'text'} thousandSeparator={true} decimalScale={2}></NumberFormat>
                            </td>
                        </tr>
                        <tr>
                            <td className="col-name">Mật độ (người/km2)</td>
                            <td>
                                <NumberFormat value={props.thongTin?.mdDanSoKm2} displayType={'text'} thousandSeparator={true} decimalScale={2}></NumberFormat>
                            </td>
                        </tr>
                        <tr>
                            <td className="col-name">Số phường xã</td>
                            <td>{props.thongTin?.PhuongXa}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Số thị trấn</td>
                            <td>{props.thongTin?.ThiTran}</td>
                        </tr>

                    </tbody>
                </table> : <h5 className="text-center">Không có thông tin</h5>
            }
        </div>
    )
};